module.exports = {
  google: {
    API_KEY: "123456",
    CLIENT_ID: "123456",
    SECRET: "123456",
  },
  facebook: {
    APP_ID: "",
  },
}
